// components/OrganizationForm.tsx
import React, { useCallback, useEffect } from "react";
import FormInput from "./FormInput";
import { postOgranization, editOrganization, removeOrganization, profileOrganization } from "api/organizations";
import Modal from "components/Modal/ConfirmationModal";
import { useOrganization } from "hooks/OrganizationContext";

interface OrganizationFormProps {
  setRefreshMode: (value: string) => void;
  setError: (value: string) => void;
  mode: 'edit' | 'create';
  formState: { id: string; name: string; desc: string };
  isModalOpen: boolean;
  setOrgStep: React.Dispatch<React.SetStateAction<number>>;
  setIsModalOpen: (value: boolean) => void;
  setFormState: React.Dispatch<React.SetStateAction<{ id: string; name: string; desc: string }>>;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  handleOrganizationWizardClose: () => void;
  onSaveSubmitFunction: (submitFn: () => void) => void;
}

const OrganizationForm: React.FC<OrganizationFormProps> = ({
  setRefreshMode,
  setError,
  mode,
  formState,
  isModalOpen,
  setOrgStep,
  setIsModalOpen,
  setFormState,
  setIsLoading,
  handleOrganizationWizardClose,
  onSaveSubmitFunction
}) => {
  const { setOrganizations } = useOrganization();
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormState({ ...formState, [name]: value });
  };

  const fetchOrganizations = useCallback(async () => {
    try {
      const response = await profileOrganization();
      if (response.status === 200 && response.data.list.length > 0) {
        setOrganizations([...response.data.list]);
      }
    } catch (error) {
      console.error('Error fetching organizations:', error);
    }
  }, [setOrganizations]);

  const submitForm = useCallback(async () => {
    setIsLoading(true);
    if (mode === 'create') {
      const response = await postOgranization(formState);
      if (response.status === 200) {
        setRefreshMode('organizations');
        fetchOrganizations();
        handleOrganizationWizardClose();
        setOrgStep(1);
      } else {
        setError(response.data);
      }
    }

    if (mode === 'edit') {
      const response = await editOrganization(formState);
      if (response.status === 200 || response.status === 204) {
        setRefreshMode('organizations');
        fetchOrganizations();
        handleOrganizationWizardClose();
        setOrgStep(1);
      } else {
        setError(response.data);
      }
    }
    setIsLoading(false);
  }, [onSaveSubmitFunction, formState, mode, setRefreshMode, fetchOrganizations, handleOrganizationWizardClose, setError]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault(); // Prevent the form's default submit action
    await submitForm();
  };


  const handleRemoveItem = async () => {
    const response = await removeOrganization(formState);
    if (response.status === 200 || response.status === 204) {
      setFormState({ name: '', id: '', desc: '' });
      setRefreshMode('organizations');
      setOrgStep(1);
      fetchOrganizations();
      handleOrganizationWizardClose();
    }
  };

  useEffect(() => {
    if (onSaveSubmitFunction) {
      onSaveSubmitFunction(submitForm);
    }
  }, [submitForm, onSaveSubmitFunction]);

  const closeModal = () => setIsModalOpen(false);

  const confirmRemove = async () => {
    setIsLoading(true);
    await handleRemoveItem();
    closeModal();
    setOrgStep(1);
    setIsLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} className="h-full text-sm xl:text-md 2xl:text-lg w-full">
      <div className="h-full w-full">
        <div className="w-full h-full">
          <FormInput
            id="orgName"
            name="name"
            value={formState.name}
            placeholder="Organization Name"
            onChange={handleInputChange}
          />
          {/* <FormInput
            id="orgDescription"
            name="desc"
            value={formState.desc}
            placeholder="Organization Description"
            onChange={handleInputChange}
          /> */}
          <div className="w-full flex flex-wrap justify-between items-center mb-4">
            <label className="block text-sm text-gray-400 mb-2">Description</label>
            <textarea
              id="orgDescription"
              value={formState.desc}
              onChange={handleInputChange}
              placeholder="Organization Description"
              name="desc"
              minLength={1}
              className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white resize-none"
            />
          </div>
        </div>

        <div className="w-full flex flex-wrap">
          <div className="flex justify-end w-full h-max mt-auto gap-2">
            {/* <AddNewItemBtn btnType="filled" type="submit" isDisabled={false}>
              {mode === 'edit' && <span>Edit Organization</span>}
            </AddNewItemBtn> */}
          </div>
        </div>
      </div>

      {/* Modal Component */}
      <Modal
        isOpen={isModalOpen}
        message="Are you sure you want to delete this item?"
        onConfirm={confirmRemove}
        onCancel={closeModal}
      />
    </form>
  );
};

export default OrganizationForm;
